import { makeAutoObservable, action } from "mobx";
import { authStore } from "./AuthStore";

class BookingFlowStore {
    currentStep = 1;
    activeStep = 1;
    showFamilyMemberStep = false;
    previousStep: number | null = null;

    appointmentData = {
        isForUser: null,
        isExistingPatient: null,
        serviceType: null,
        appointmentType: null,
        selectedDoctor: null,
        selectedTime: null,
        userAuthenticated: false,
        selectedFamilyMember: null,
    };

    isModalOpen = false;

    appointmentDetails: any = null;


    constructor() {
        makeAutoObservable(this);
    }

    setIsModalOpen(isOpen: boolean) {
        // if (isOpen) {
        //     console.log("User is begining booking process");
        // }
        this.isModalOpen = isOpen;
    }

    isBookingConfirmed = false;

    @action.bound
    setCurrentStep(step: number) {
        this.currentStep = step;
    }

    @action.bound
    clearPreviousStep() {
        this.previousStep = null;
    }

    @action.bound
    setAppointmentDetails(details: any) {
        this.appointmentDetails = details;
    }

    nextStep() {
        if (this.currentStep < 10) {
            this.previousStep = this.currentStep;
            this.currentStep += 1;
        } else if (this.currentStep === 10) {
            this.previousStep = null;
            this.currentStep += 1;
        }
    }

    prevStep() {
        if (this.currentStep > 1) {
            this.currentStep -= 1;
        }
    }

    goToLogin() {
        this.previousStep = this.currentStep;
        this.currentStep = 8;
    }

    returnToPreviousStep() {
        if (this.previousStep !== null) {
            this.setCurrentStep(this.previousStep);
            this.previousStep = null;
        } else {
            this.currentStep = 9;
        }
    }

    setSelectedFamilyMember(familyMember: any) {
        this.appointmentData = {
            ...this.appointmentData,
            selectedFamilyMember: familyMember,
        };
    }

    goToStep(step: number) {
        if (step >= 1 && step <= 10) {
            this.previousStep = this.currentStep;
            this.currentStep = step;
        }
    }

    setActiveStep(step: number) {
        this.activeStep = step;
    }

    setShowFamilyMemberStep(show: boolean) {
        this.showFamilyMemberStep = show;
    }

    updateAppointmentData(field: keyof BookingFlowStore["appointmentData"], value: any) {
        this.appointmentData = {
            ...this.appointmentData,
            [field]: value,
        };
    }

    handleBackClick = async () => {
        // console.log("CALLING THE BACK BUTTON")
        if (this.currentStep === 5) {
            this.updateAppointmentData("appointmentType", null);
            this.goToStep(4);
            this.setActiveStep(3);
        } else if (this.currentStep === 1) {
            if (this.showFamilyMemberStep === true) {
                this.setShowFamilyMemberStep(false);
            } else {
                this.isModalOpen = false;
            }
            return;
        } else if (this.currentStep === 3) {
            if (await authStore.isLoggedIn()) {
                this.setShowFamilyMemberStep(false);
                this.updateAppointmentData("serviceType", null);
                this.goToStep(1);
                this.setActiveStep(0);
            } else {
                this.goToStep(2);
                this.setActiveStep(1);
            }
        } else if (this.currentStep === 5) {
            this.updateAppointmentData("appointmentType", null);
            this.goToStep(3);
            this.setActiveStep(2);
        } else if (this.currentStep === 6) {
            this.updateAppointmentData("appointmentType", null);
            this.goToStep(3);
            this.setActiveStep(2);
        } else if (this.currentStep === 7) {
            this.updateAppointmentData("selectedDoctor", null);
            this.goToStep(6);
            this.setActiveStep(6);
        } else if (this.currentStep === 8) {
            this.updateAppointmentData("selectedTime", null);
            this.updateAppointmentData("selectedDoctor", null);
            this.goToStep(6);
            this.setActiveStep(6);
        } else if (this.currentStep === 9) {
            this.updateAppointmentData("selectedTime", null);
            this.updateAppointmentData("selectedDoctor", null);
            this.goToStep(6);
            this.setActiveStep(6);
        } else if (this.currentStep === 10) {
            this.updateAppointmentData("selectedTime", null);
            this.updateAppointmentData("selectedDoctor", null);
            this.goToStep(6);
            this.setActiveStep(6);
        } else if (this.currentStep > 1) {
            this.prevStep();
            this.setActiveStep(this.currentStep);
        }
    };

    resetFlow() {
        this.currentStep = 1;
        this.previousStep = null;
        this.appointmentData = {
            isForUser: null,
            isExistingPatient: null,
            serviceType: null,
            appointmentType: null,
            selectedDoctor: null,
            selectedTime: null,
            userAuthenticated: false,
            selectedFamilyMember: null,
        };
        this.isModalOpen = false;
        this.activeStep = 1;
        this.showFamilyMemberStep = false;
    }
}

export const bookingFlowStore = new BookingFlowStore();
